import { sharedEnvironmentAcc } from './shared-environment.acc';
import { sharedEnvironmentLocal } from './shared-environment.local';
import { sharedEnvironmentProd } from './shared-environment.prod';
import { sharedEnvironmentSys } from './shared-environment.sys';
import { sharedEnvironmentUtv } from './shared-environment.utv';

const SharedEnvironment = {
  getMsalConfig(
    apiResource: string,
    frontendClientId: string,
    backendClientId: string,
    redirectUri: string,
  ) {
    return {
      authority:
        'https://login.microsoftonline.com/4b552844-3bd0-4e19-bfd3-a566ea76a7b6',
      frontendClientId: frontendClientId,
      backendClientId: backendClientId,
      redirectUri: redirectUri,
      apiResource: apiResource,
    };
  },

  getB2CMsalConfig(
    apiResource: string,
    frontendClientId: string,
    backendClientId: string,
  ) {
    return {
      apiResource: apiResource,
      frontendClientId: frontendClientId,
      backendClientId: backendClientId,
    };
  },
};

export const sharedEnvironment = {
  local: sharedEnvironmentLocal,
  utv: sharedEnvironmentUtv,
  sys: sharedEnvironmentSys,
  acc: sharedEnvironmentAcc,
  prod: sharedEnvironmentProd,
  msalConfig: SharedEnvironment.getMsalConfig,
  b2cMsalConfig: SharedEnvironment.getB2CMsalConfig,
};
